import apiServiceNew from './apiService.new';
import appConfigService from '_app/services/appConfigService';

export default (function () {

	const servicePath = 'MediaHubItems/';
	const recentsPath = servicePath + 'Recents';
	const featuredPath = servicePath + 'Featured';
	const favoritesPath = servicePath + 'Favorites';

	function getRecentMedia(proxiedAsId) {
		return apiServiceNew.get(recentsPath, {
			params: getMediaHubDashbaordParameters(proxiedAsId)
		});
	}

	function getFeaturedMedia(proxiedAsId) {
		return apiServiceNew.get(featuredPath, {
			params: getMediaHubDashbaordParameters(proxiedAsId)
		});
	}

	function getFavoriteMedia(proxiedAsId) {
		return apiServiceNew.get(favoritesPath, {
			params: getMediaHubDashbaordParameters(proxiedAsId)
		});
	}

	function getMediaHubDashbaordParameters(proxiedAsUserId) {
		return {
			includeEmailSection: appConfigService.get('allowEmail'),
			includeCampaigns: appConfigService.get('allowCampaign'),
			proxiedAsUserId: proxiedAsUserId
		};
	}

	return {
		getRecentMedia: getRecentMedia,
		getFeaturedMedia: getFeaturedMedia,
		getFavoriteMedia: getFavoriteMedia,
	};

})();